import { Injectable } from '@angular/core';

import { Fai } from '@bytel/bytel-sales';
import { CheckoutStorageService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

@Injectable({
    providedIn: 'root',
})
export class Ftth3ClicsService {
    public static readonly PRESELECT_DAYS_NUMBER: number = 11;
    private readonly _storageKey: string = 'ftth3Clics';

    public constructor(
        protected checkoutStorageService: CheckoutStorageService,
        private cartService: MainCartService,
    ) {}

    public isActive(): boolean {
        const fai: Fai = this.cartService.getQuoteFai()?.getProductByType(Fai);
        return (
            fai?.technology === Fai.TECHNOLOGIES.FTTH &&
            this.checkoutStorageService.get(this._storageKey, false) === true
        );
    }

    public stopUsingFtth3Clics(): void {
        this.checkoutStorageService.set(this._storageKey, false, false);
    }

    public startFtth3Clics(): void {
        this.checkoutStorageService.set(this._storageKey, true, false);
    }
}
